import React, {useState, useCallback, useEffect} from "react";
import {Form, Input, Button, Row, Col, message} from "antd";

import {apiSendCode} from './model/api'
import styles from "./index.scss";

const layout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 24 },
};

const FormComponent = props => {
    const {onCodeLogin} = props;
    const [form] = Form.useForm();

    const [countdown, setCountdown] = useState(0);
    const [sendCodeLoading, setSendCodeLoading] = useState(false);
    
    const handleSendCode = useCallback(() => {
        form.validateFields(['userName']).then(async res => {
            setSendCodeLoading(true);
            const userName = res.userName;
            try {
                const res = await apiSendCode({userName});
                if (res.code === 0) {
                    setCountdown(60);
                }
                else {
                    message.error(res.message);
                }
            }
            catch (err) {
                message.error(err);
            }
            setSendCodeLoading(false);
        })
    }, [form]);

    const handleSubmit = useCallback(async () => {
        form.validateFields().then(val => {
            onCodeLogin(val);
        })
    }, [form, onCodeLogin])
    
    useEffect(() => {
        let interval: NodeJS.Timeout;
        if (countdown) {
            interval = setInterval(() => {
                setCountdown((prevState: number) => {
                    if (prevState > 0) {
                        return prevState - 1;
                    } else {
                        clearInterval(interval);
                        return 0;
                    }
                })
            }, 1000)
        }
        return () => clearInterval(interval)
    }, [countdown]);

    return (
        <Form
            initialValues={{ remember: true }}
            name="login"
            form={form}
            {...layout}
        >
            <Form.Item
                name="userName"
                rules={[{ required: true, message: '请输入账号名或手机号' }]}
            >
                <Input placeholder={"请输入账号名或手机号"} />
            </Form.Item>

            <Form.Item
                name="code"
                rules={[{ required: true, message: '请输入验证码' }]}
            >
                 <Row>
                    <Col span={14}>
                        <Input placeholder={"请输入验证码"} />
                    </Col>
                    <Col offset={1} span={9}>
                        <Button
                            className={styles.codeBtn}
                            disabled={countdown > 0}
                            loading={sendCodeLoading}
                            onClick={handleSendCode}
                        >{countdown > 0 ? `${countdown}秒` : '获取短信验证码'}</Button>
                    </Col>
                </Row>
            </Form.Item>
            <Button type="primary" htmlType="submit" onClick={handleSubmit}>
                登录
            </Button>
        </Form>
    );
};

export default FormComponent;